<template>
  <QTable
    v-model:pagination="tablePagination"
    v-model:selected="selectedUsers"
    :columns="columns"
    :loading="loading"
    row-key="id"
    :rows="users"
    :rows-per-page-options="rowPerPage"
    selection="multiple"
    @request="onRequest"
  >
    <!-- Search bar -->
    <template #top-row>
      <QTr class="filter-row">
        <QTd />
        <QTd>
          <QInput
            v-model="filters.id.value"
            borderless
            clearable
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd>
          <QInput
            v-model="filters.firstName.value"
            borderless
            clearable
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd>
          <QInput
            v-model="filters.lastName.value"
            borderless
            clearable
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd>
          <QInput
            v-model="filters.email.value"
            borderless
            clearable
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd>
          <QInput
            v-model="filters.teamName.value"
            borderless
            clearable
            dense
            placeholder="Search"
            square
          />
        </QTd>
        <QTd />
      </QTr>
    </template>
  </QTable>
</template>

<script>
export default {
  name: "SelectUsersTable",
  props: {
    users: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:pagination", "update:filters", "update", "request"],
  data() {
    return {
      selectedUsers: [],
      columns: [
        {
          name: "id",
          required: true,
          label: "ID",
          align: "left",
          field: "id",
          style: "width: 20%",
          classes: "wrap-table-content",
          sortable: true,
        },
        {
          name: "first_name",
          required: true,
          label: "First Name",
          align: "left",
          field: "firstName",
          style: "width: 30%",
          classes: "wrap-table-content",
          sortable: true,
        },
        {
          name: "last_name",
          required: true,
          label: "Last name",
          align: "left",
          field: "lastName",
          style: "width: 30%",
          classes: "wrap-table-content",
          sortable: true,
        },
        {
          name: "email",
          required: true,
          label: "Email",
          align: "left",
          field: "email",
          style: "width: 30%",
          classes: "wrap-table-content",
          sortable: true,
        },
        {
          name: "team_name",
          required: true,
          label: "Team",
          align: "left",
          field: (row) => row.teamName,
          style: "width: 20%",
          classes: "wrap-table-content",
          sortable: true,
        },
      ],
      rowPerPage: [25, 50, 100, 250, 500],
    };
  },
  computed: {
    tablePagination: {
      get() {
        return this.pagination;
      },
      set(value) {
        this.$emit("update:pagination", value);
      },
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(value) {
        this.$emit("update:filters", value);
      },
    },
    selectedUsers: {
      deep: true,
      handler(val) {
        this.$emit("update", val);
      },
    },
  },
  methods: {
    onRequest({ pagination }) {
      this.$emit("update:pagination", pagination);
      this.$emit("request");
    },
  },
};
</script>
